import React from 'react';
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Dashboard from '../Components/User-Dashboard/Dashboard';
import Breadcrumbs from '../Components/banner/New-banner';

function Userpage() {
    return (
        <>

            <Combaintop />
            <Breadcrumbs />
            <Dashboard />
            <Combainbottom />
        </>
    );
}
export default Userpage;
